import { render } from "./DashboardLayout.vue?vue&type=template&id=4d3fdfcb"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
script.render = render

export default script